// Import container component
import ServicesContainer from './ServicesContainer';

// Re-export container component as the public API
export const Services = ServicesContainer;

// Also export the presentational components for testing and documentation
export { default as ServicesPresentation } from './ServicesPresentation';
export { default as ServiceItemPresentation } from './ServiceItemPresentation';